/**
 * Determines the equality between {@link v1} and {@link v2} via
 * {@link Object.is} or, when `!Object.is(v1, v2)`, via an `equals` function in
 * {@link v1} (when defined).
 * @param v1 First value being compared (if `!Object.is(v1, v2)` and `v1.equals`
 * is a function, then `v1.equals(v2)` is used to determine the equality).
 * @param v2 Second value being compared.
 * @returns Whether {@link v1} and {@link v2} are considered equal.
 */
export function equals(v1: any, v2: any): boolean {
  return (
    Object.is(v1, v2) || (typeof v1?.equals === "function" && !!v1.equals(v2))
  );
}
